import {
  LogIn, LogOut, CircleStop, Sparkles, GitBranch, Wrench, Puzzle, Plug, Box,
  Bot, ShieldCheck, Image, Repeat, Timer, Globe, Workflow, FunctionSquare, Network,
} from 'lucide-react';

/**
 * Icon NAME (as the server's node catalog and palette entries spell it) → lucide component.
 *
 * One map, two consumers: the palette rows and the canvas cards. They each had their own
 * before, and both were missing `function-square`, so a Transform node fell back to a
 * generic box on both surfaces at once — the same drift twice over.
 *
 * lucide is imported BY NAME, never looked up dynamically, so the tree-shaker can see which
 * icons are reachable. An unknown name falls back to Box rather than rendering nothing: a
 * node type this map has not caught up with must still be visible and draggable.
 */
const ICONS = {
  'log-in': LogIn,
  'log-out': LogOut,
  'circle-stop': CircleStop,
  sparkles: Sparkles,
  'git-branch': GitBranch,
  wrench: Wrench,
  puzzle: Puzzle,
  plug: Plug,
  bot: Bot,
  'shield-check': ShieldCheck,
  image: Image,
  repeat: Repeat,
  timer: Timer,
  globe: Globe,
  workflow: Workflow,
  'function-square': FunctionSquare,
  network: Network,
  box: Box,
};

export function iconFor(name) {
  return ICONS[name] || Box;
}

export default ICONS;
